import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {searchBulkProducts, showDeleteBulkProductModal} from "./actions";
import ListView from "../common/ListView";
import {getSuppliers} from "../Supplier/actions";
import {NormalisedUnitForClass} from "../BulkConsignment/NormalisedQuantityDisplay";
import {Link} from "react-router-dom";
import DeleteBulkProductFormModal from "../BulkProduct/DeleteBulkProductFormModal";

class BulkProductsPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    /* state */
    dispensaryId: PropTypes.string,
    search: PropTypes.object.isRequired,
    suppliers: PropTypes.array.isRequired,
    deleteBulkProductModalVisible: PropTypes.bool.isRequired,
    /* actions */
    searchBulkProducts: PropTypes.func.isRequired,
    getSuppliers: PropTypes.func.isRequired,
    showDeleteBulkProductModal: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.dispensaryId !== prevProps.dispensaryId) this.load();
  }

  load = () => {
    const {dispensaryId, getSuppliers} = this.props;
    getSuppliers({dispensaryId});
  };

  render() {
    const {
      history, searchBulkProducts, dispensaryId, suppliers, deleteBulkProductModalVisible,
      search: {searching, pagination, filters, sorter, searchFilter, results},
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        sorter: true,
        className: 'truncated-column',
      },
      {
        title: 'Supplier',
        dataIndex: 'supplierName',
        key: 'supplierId',
        sorter: true,
        filters: suppliers.map(s => ({text: s.name, value: s.supplierId})),
      },
      {
        title: 'Unit Class',
        dataIndex: 'unitOfMeasureClass',
        key: 'unitOfMeasureClass',
        sorter: true,
        filters: Object.keys(NormalisedUnitForClass).map(c => ({text: c, value: c})),
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, bulkProduct) => {
          return (<span><Link key='update' to={`/bulk-product/update/${bulkProduct.bulkProductId}`}>Edit</Link> | <a
            onClick={() => this.props.showDeleteBulkProductModal(bulkProduct)}>Delete</a>
        </span>);
        }
      }
    ];
    return (<React.Fragment>
        {deleteBulkProductModalVisible && <DeleteBulkProductFormModal onDelete={() => this.listView.refresh()}/>}
        <ListView
          ref={ref => this.listView = ref}
          dispensaryId={dispensaryId}
          title="Bulk Products"
          searchPlaceholder="Search name, description, supplier, unit class"
          loading={searching}
          columns={columns}
          dataSourceProvider={searchBulkProducts}
          dataSource={results}
          pagination={pagination}
          searchFilter={searchFilter}
          filters={filters}
          sorter={sorter}
          onAdd={() => history.push('/bulk-product/add')}
          rowKey="bulkProductId"
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.bulkProduct.bulkProductsLoading,
  dispensaryId: state.dispensary.selectedDispensaryId,
  suppliers: state.supplier.suppliers,
  search: state.bulkProduct.search,
  deleteBulkProductModalVisible: state.bulkProduct.deleteBulkProductModalVisible,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchBulkProducts,
  getSuppliers,
  showDeleteBulkProductModal,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(BulkProductsPage);



// WEBPACK FOOTER //
// ./src/BulkProduct/BulkProductsPage.js